<template>
  <header id="header">
    <div id="not_found_div">
      <div class="inner_static">
        <a id="btn_top" @click="btnTopClick()"></a>
        <h1 id="h_logo" class="kagull_logo_h1" :style="logoStyle">
          <strong>カグル.</strong>
        </h1>
      </div>
    </div>
  </header>
</template>

<script>
import * as App from '../../../utils/App'

export default {
  data () {
    return {
      logoStyle: {
        background: 'url(' + this.getImage() + ') no-repeat 0 0',
        backgroundSize: 'auto 24px',
        webkitBackgroundSize: 'auto 24px',
        mozBackgroundSize: 'auto 24px'
      }
    }
  },
  methods: {
    btnTopClick: function () {
      this.$router.push('/kagull/login')
    },
    getImage: function () {
      return App.getKagullResource('logo1.png')
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/NotFoundHeader.vue